import React from "react";
import api from "../../../services/api/axios";
import ProspectingTagEditor from "../shared/ProspectingTagEditor";

export default function WebsiteVisitTags({
  visitId,
  userTags,
  autoTags,
  onTagsUpdated,
}) {
  return (
    <ProspectingTagEditor
      entityId={visitId}
      userTags={userTags}
      autoTags={autoTags}
      layout="column"
      onCommit={async (tags) => {
        const { data } = await api.patch(`/website-visits/${visitId}/tags`, {
          tags,
        });
        onTagsUpdated?.(data);
        return data?.user_tags ?? tags;
      }}
      onTagsUpdated={(tags) => {
        onTagsUpdated?.({
          visit_id: visitId,
          user_tags: tags,
        });
      }}
    />
  );
}
